/** @module Specification/SizeMap/EditSizeMapController */
define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"./_ControllerMixin"
], function(declare,EditController,_ControllerMixin) {

	return declare([EditController,_ControllerMixin], {
		/**
		 * @override
		 * Allow editing in popup view
		 */
		onFormData: function(fd) {
			fd.m_bAllowSelections = false;
			fd.m_bEditable = true;
		},

		/**
		 * @override
		 * Write operation to server
		 */
		toWriter: function() {
			this.popupView.onActionSizeChanges(this);
		}
	});
});